import { Layout } from "@/components/layout/Layout";
import { motion } from "framer-motion";

export default function Privacy() {
  return (
    <Layout>
      <section className="pt-32 pb-20 bg-background">
        <div className="container px-4 max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="font-heading text-4xl font-bold text-foreground mb-8">
              מדיניות פרטיות
            </h1>
            
            <div className="prose prose-lg max-w-none text-muted-foreground">
              <p className="lead">
                אנו ב-אדם בטיחות מכבדים את פרטיותכם ומחויבים להגן על המידע האישי שלכם.
              </p>

              <h2 className="text-foreground">איסוף מידע</h2>
              <p>
                אנו אוספים מידע שאתם מספקים לנו ישירות, כגון שם, כתובת דוא"ל, מספר טלפון ופרטי החברה שלכם, 
                כאשר אתם פונים אלינו דרך טפסי יצירת קשר או מבקשים שירותים.
              </p>

              <h2 className="text-foreground">שימוש במידע</h2>
              <p>אנו משתמשים במידע שנאסף כדי:</p>
              <ul>
                <li>לספק את השירותים שביקשתם</li>
                <li>ליצור אתכם קשר בנוגע לפניותיכם</li>
                <li>לשלוח עדכונים ומידע רלוונטי (באישורכם)</li>
                <li>לשפר את השירותים שלנו</li>
              </ul>

              <h2 className="text-foreground">שיתוף מידע</h2>
              <p>
                אנו לא מוכרים, סוחרים או מעבירים לצדדים שלישיים את המידע האישי שלכם, 
                למעט במקרים הנדרשים לספק לכם את השירותים או כנדרש על פי חוק.
              </p>

              <h2 className="text-foreground">אבטחת מידע</h2>
              <p>
                אנו מיישמים אמצעי אבטחה מתאימים כדי להגן על המידע האישי שלכם מפני גישה, 
                שינוי, חשיפה או השמדה בלתי מורשים.
              </p>

              <h2 className="text-foreground">עוגיות (Cookies)</h2>
              <p>
                האתר שלנו עשוי להשתמש בעוגיות כדי לשפר את חווית הגלישה שלכם. 
                תוכלו לבחור לחסום עוגיות דרך הגדרות הדפדפן שלכם.
              </p>

              <h2 className="text-foreground">זכויותיכם</h2>
              <p>
                יש לכם זכות לבקש גישה למידע האישי שלכם, לתקן אותו או למחוק אותו. 
                לכל בקשה, אנא צרו איתנו קשר.
              </p>

              <h2 className="text-foreground">יצירת קשר</h2>
              <p>
                לשאלות בנוגע למדיניות הפרטיות שלנו, אנא צרו קשר בכתובת: Support@Adam-Safety.com
              </p>

              <p className="text-sm text-muted-foreground mt-8">
                עדכון אחרון: ינואר 2024
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </Layout>
  );
}
